import styled from 'styled-components';

export const AsideContainer = styled.aside`
  width: 15%;
  float: right;
  margin-top:47px;

  div.widget {
    margin-bottom: 38px;
    h4.widget-title {
      border: 1px solid;
      border-color: #c69f73;
      font-size: 10px;
      color: #000;
      text-transform: uppercase;
      letter-spacing: 2px;
      font-family: "Lato";
      font-weight: 700;
      text-align: center;
      margin-bottom: 25px;
      padding: 16px 0;
    }
    div.about-widget {
      text-align: center;
      img {
        border-radius: 50%;
        margin-bottom: 10px;
        max-width: 100%;
        height: auto;
      }
      p {
        line-height: 24px;
      }
    }
    div.social-widget {
      text-align: center;
      a:first-child {
        margin-left: 0;
      }
      a:hover>i {
        color: #c69f73;
      }
      a {
        i {
          height: 16px;
          width: 20px;
          text-align: center;
          line-height: 20px;
          color: #161616;
          border-radius: 50%;
          margin: 0 8px;
          font-size: 16px;
        }
      }
    }
  }
`;